import React, { FC } from 'react';
import { t, useBehaviorSubject } from '../../../utils/helpers';
import { Message } from '../message';
// import { ITable } from '../../game/model/interfaces';
import { useTableChat } from '../hooks/useTableChat';
import send from '../../../assets/images/paper_plane.svg';
import { EmojiPicker } from '../emojiPicker/emojiPicker';
import { useScrollToElem } from '@utils/hooks';
import { Loader } from '@ui-kit/components/loader';
import { container } from 'tsyringe';

export const TableChat: FC = () => {
  const { message, messages, handleMessage, sendMessage, handleEmoji, joinPrivatChat } = useTableChat();

  function joinPrivatChatBtnJSX(pid?: number, recipientName?: string) {
    if (pid && recipientName) {
      return (
        <button className="messages__button-table" onClick={() => joinPrivatChat(pid)}>
          {t('chat')}
        </button>
      );
    }
  }

  function renderTableMessages(messages: Message[]) {
    return messages?.map((elem, index) => {
      const authorJSX = elem.senderName ? (
        <div
          className={elem.recipientName ? 'messages__author messages__author--private' : 'messages__author'}
        >
          {elem.senderName}:
        </div>
      ) : (
        ''
      );

      return (
        <div className="messages-list" key={`${elem.text}_${index}`}>
          {authorJSX}
          <div
            style={{ color: authorJSX ? 'white' : '#40E3FC' }}
            className="messages__text"
          >{`${elem.text}`}</div>
          <div className="messages__button-wrap">{joinPrivatChatBtnJSX(elem.pid, elem.recipientName)}</div>
        </div>
      );
    });
  }

  const endElem = useScrollToElem();

  return (
    <>
      <main className="lobby-chat__messages">
        {messages && renderTableMessages(messages)}
        <div ref={endElem} />
      </main>
      <footer className="lobby-chat__footer">
        <form className="messages-form" action="" onSubmit={(e) => sendMessage(e)}>
          <div className="messages-form__send-area">
            <input
              className="messages-form__input"
              type="text"
              value={message}
              placeholder={`${t('input_text_here')}...`}
              onChange={handleMessage}
            />
          </div>
          <div className="messages-form__emoji">{/* <EmojiPicker handleEmoji={handleEmoji} /> */}</div>
          <div className="messages-form__send">
            <button className="messages-form__button-send">
              <img src={send} alt="button send" />
            </button>
          </div>
        </form>
      </footer>
    </>
  );
};
